module.exports = __webpack_public_path__ + "static/lemonchickonesie3-069ff4520a3f31f265018bbc0d710541.jpeg";